export function setLocalStore (key, value, expire = 1) {
  const o = {
    value,
    time: new Date().getTime(),
    expire
  }
  localStorage.setItem(key, JSON.stringify(o))
}
export function getLocalStore (key, callback) {
  const str = localStorage.getItem(key)
  if (!str) {
    if (callback) {
      callback()
    }
    return null
  }
  const o = JSON.parse(str)
  return o.value
}
export function removeLocalStore (key) {
  localStorage.removeItem(key)
}
export function clearLocalStore () {
  localStorage.clear()
}
